module.exports = __webpack_public_path__ + "img/bd.5102bab0.svg";